import { InfoIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
  Box, Button, Checkbox, CheckboxGroup,
  Collapse,
  Divider, Flex, Icon, Input, Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select, Text, Textarea, Tooltip, useToast,
  useColorModeValue,
  Card,
  CardBody,
  Link
} from '@chakra-ui/react';
import DriveModal from 'components/drive/DriveModal';
import DeleteConfirmationModal from 'components/genericForms/DeleteConfirmationModal';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FiChevronUp, FiPhoneCall } from "react-icons/fi";
import { MdBlock, MdDelete, MdEdit } from "react-icons/md";
import PhoneInput from 'react-phone-input-2';
import { useCreateAdspressoCreativeMutation, useRemoveAdMutation, useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetAdvertisableAppsByIdQuery } from 'store/campaigns/adsetFormApi';
import { formatDateTime, getFileNameWithoutExtension, removeEmptyValues, truncateString, formatCardIndices } from 'utils/functions';
import { object, string } from "yup";
import BuildUrlParams from '../BuildUrlParams';
import BuildUrlParamSingle from '../BuildUrlParamSingle';
import UrlParameter from '../UrlParameter';
import { selectCallsData, selectLandersData } from 'store/aiHub/aiSlice';
import { useSelector } from 'react-redux';
import { IoBuildOutline } from 'react-icons/io5';
import { call_to_action_options_Awareness_Traffic_Engagement } from 'utils/callToActions';

function isValidUrl(url) {
  const regex = /^(https?:\/\/)?([\w\d\-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  return regex.test(url);
}

const isValidPhoneNumber = (phoneNumber) => {
  const countryCodePattern = /^[0-9]{2}/;
  const phoneNumberPart = phoneNumber.slice(2); // Remove the first 2 digits (country code)
  const regex = /^[0-9]{10}$/;
  return countryCodePattern.test(phoneNumber) && regex.test(phoneNumberPart);
};

function CarouselObjectiveMediaCreative({ adsAccounts, adFormik, objective, adsetsListData, campaignId, adData }) {
  const bgColor = useColorModeValue("#f8f6fb", "#1e1530");
  const boxBorder = useColorModeValue("gray.200", "gray.700");
  const ListBgColor = useColorModeValue('#fff', 'gray.800');
  const hoverBorder = useColorModeValue('gray.50', 'gray.700');
  const toast = useToast();
  const landersData = useSelector(selectLandersData);
  const callsData = useSelector(selectCallsData);
  const userInfo = useSelector((state) => state.auth?.userInfo);
  const [isDriveOpen, setIsDriveOpen] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  const [uploadPurpose, setuploadPurpose] = useState(null);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [selectedAdSets, setSelectedAdSets] = useState({});
  const [mediaFiles, setMediaFiles] = useState([]);
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [fileBeingEdited, setFileBeingEdited] = useState(null);
  const [mediaFilesState, setMediaFilesState] = useState({});
  const [maxCards] = useState(10);
  const [hasSameDestinationType, sethasSameDestinationType] = useState(true);
  const [activeDestinationType, setactiveDestinationType] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const [links, setLinks] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [isUrlModalOpen, setUrlModalOpen] = useState(false);
  const [isSingleUrlModalOpen, setSingleUrlModalOpen] = useState(false);
  const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [url_tags, seturl_tags] = useState([]);
  const [isFocused, setIsFocused] = useState({});
  const [showSavedPhones, setShowSavedPhones] = useState({});
  const [showSavedLanders, setShowSavedLanders] = useState({});

  const [createAdspressoAds, { isLoading: isAdsCreating, error: createError }] = useCreateAdspressoCreativeMutation();
  const [updateAdspressocreativeAds, { isLoading: isAdspressoAdsetUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});
  const [removeAd, removeAdResponse] = useRemoveAdMutation();

  const adsAccountIds =  adData?.adsAccounts.map(account => account?.adsAccountId);

  const { data: advertisableApps } = useGetAdvertisableAppsByIdQuery({
    adsAccountIds
  }, {
    skip: !adsAccountIds
  });

  const toggleAccordion = (id) => {
    setOpenAccordionId(openAccordionId === id ? null : id);
  };


  const handleInputChange = (fileId, field, value) => {

    setMediaFilesState(prevState => ({
      ...prevState,
      [fileId]: {
        ...prevState[fileId],
        [field]: value,
      },
    }));
  };

  const handleMediaTypeChange = (adAccounts, type) => {
    setSelectedAdAccounts(adAccounts);
    setMediaType(type);
    setIsDriveOpen(true);
  }

  const handleAdAccountChange = (selectedValues) => {
    const selectedAccounts = adsAccounts.filter(account => selectedValues.includes(account.adsAccountId));
    setSelectedAdAccounts(selectedAccounts);

    // Filter out media files associated with deselected accounts
    const updatedMediaFiles = mediaFiles.filter(file =>
      selectedValues.includes(file?.adsAccount?.adsAccountId)
    );

    setMediaFiles(updatedMediaFiles);

    // Update links state with initial empty URLs for selected ad accounts
    setLinks(prevLinks => {
        const updatedLinks = selectedAccounts.map(account => {
          const existing = prevLinks.find(link => link?.adsAccountId === account?.adsAccountId);
          return {
            adsAccountId: account?.adsAccountId,
            link: existing?.link || '',
            caption: existing?.caption || '',
            app_id: existing?.app_id || '',
          };
        });
        return updatedLinks;
    });

    // Update phoneNumbers state with initial empty phone numbers for selected ad accounts
    setPhoneNumbers(prevPhoneNumbers => {
      const updatedPhoneNumbers = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        phoneNumber: prevPhoneNumbers.find(phone => phone?.adsAccountId === account?.adsAccountId)?.phoneNumber || '' // keep previous value if exists
      }));
      return updatedPhoneNumbers;
    });

    seturl_tags(prevUrl => {
      const updatedurl_tags = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        url_tags: prevUrl.find(url => url?.adsAccountId === account?.adsAccountId)?.url_tags || '' // keep previous value if exists
      }));
      return updatedurl_tags;
    });
  };

  const handleAdSetChange = (selectedValues) => {
    setSelectedAdSets(prev => {
      const updated = {};
      selectedAdAccounts.forEach(account => {
        updated[account.adsAccountId] = selectedValues;
      });
      return updated;
    });
  };

  useEffect(() => {
    if (mediaFiles.length > 0) {
      setOpenAccordionId(mediaFiles[0]._id);
    }
  }, [mediaFiles]);

  const handleFileSelect = (files) => {

    if (files.length > 0) {
      if (fileBeingEdited) {
        // Handle update scenario
        setMediaFiles(files);
        const selectedFile = files[0];
        const strippedName = getFileNameWithoutExtension(selectedFile?.name)?.trim();
        const fileName = strippedName ? strippedName : `Ad_${formatDateTime()}`;

        const payload = {
          [selectedFile?.creativeType === 'video' ? 'video_id' : 'image_hash']: selectedFile?.creativeId,
          ...(selectedFile?.creativeType === 'image' ? { url: selectedFile?.url } : { thumbnail: selectedFile?.picture }),
          hash: selectedFile?.hash,
          fileName: fileName
        };

        updateAdspressocreativeAds({ adcreativeId: fileBeingEdited?._id, payload }).unwrap()
          .then(response => {
            console.log('Ad creative updated successfully:', response);
          })
          .catch(error => {
            toast({
              position: "top-right",
              title: "Error updating image",
              status: "error",
              duration: 4000,
              isClosable: true,
            });
          });
      } else {
        // Handle creation scenario
        setMediaFiles(prevFiles => {
          // Add new files only if the total number of files is less than maxCards
          const newFiles = [...prevFiles, ...files].slice(0, maxCards);
          return newFiles;
        });
      }
      setFileBeingEdited(null);
    }
  };

  const truncateName = (name, maxLength = 14) => {
    if (name?.length > maxLength) {
      return name?.substring(0, maxLength) + '...';
    }
    return name;
  };

  let schema = object().shape({
    destinationType: string(),
    type: string()
      .max(300, 'select atleast one type')
      .required('Type is required'),
  })

  const singleMediaFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      destinationType: activeDestinationType,
      message: '',
      name: '',
      description: '',
      link: [],
      type: activeDestinationType === 'PHONE_CALL' ? 'CALL_NOW' : 'SHOP_NOW',
      mediaFiles: [],
      phoneNumber: [],
      url_tags: [],
    },
    validationSchema: schema,
    onSubmit: (values, { resetForm }) => {

      const { name, message, description, type, link, phoneNumber, url_tags } = values;

      const urlTags = url_tags.filter(account => account.url_tags?.trim());

      const adcreatives = mediaFiles?.map(file => {

        let videoId = file?.creativeType == 'video' ? { video_id: file?.creativeId } : null;
        let videoURL = file?.creativeType == 'video' ? { url: file?.source } : null;
        let imageHash = file?.creativeType == 'image' ? { image_hash: file?.creativeId } : null;
        let imageURL = file?.creativeType == 'image' ? { url: file?.url } : null;
        let videoThumbnail = file?.creativeType == 'video' ? { thumbnail: file?.picture } : null;

        return (
          {
            adsAccountId: file?.adsAccount?.adsAccountId,
            message: mediaFilesState[file?.id || file?.creativeId]?.message || '',
            name: mediaFilesState[file?.id || file?.creativeId]?.name || '',
            description: mediaFilesState[file?.id || file?.creativeId]?.description || '',
            link: activeDestinationType == 'PHONE_CALL' ? `tel:+${mediaFilesState[file?.id || file?.creativeId]?.link}` : mediaFilesState[file?.id || file?.creativeId]?.link || '',
            type: activeDestinationType == 'PHONE_CALL' ? 'CALL_NOW' : type,
            hash: file?.hash,
            ...videoId,
            ...videoURL,
            ...imageHash,
            ...imageURL,
            ...videoThumbnail,
          }
        )
      });

      const adsAccounts = selectedAdAccounts.map(account => ({
        id: account?.id,
        adsAccountId: account?.adsAccountId,
        adsAccountName: account?.adsAccountName,
        businessName: account?.businessName,
        businessId: account?.businessId,
      }));

      const adsets = adsAccounts.flatMap(account => selectedAdSets[account.adsAccountId] || []);
      const uniqueAdsets = adsets.filter((item, index) => adsets.indexOf(item) === index);

        const linksPayload = link
            .filter(item => item.link?.trim() !== '' || item.caption?.trim() !== '')
            .map(item => ({
                adsAccountId: item.adsAccountId,
                link: item.link,
                caption: item.caption,
        }));

        const templateUrlSpec = link
            .filter(item => item.app_id?.trim())
            .map(item => ({
                adsAccountId: item.adsAccountId,
                app_id: item.app_id,
        }));

      const rawFileName = getFileNameWithoutExtension(mediaFiles[0]?.name)?.trim();
      const fallbackFileName = rawFileName ? rawFileName : `Ad_${formatDateTime()}`;

      const intialPayload = {
        adType: adFormik.values.format,
        contextual_multi_ads: {
          enroll_status: adFormik.values.enroll_status,
        },
        campaign: campaignId,
        adsets: uniqueAdsets,
        fileName: fallbackFileName,
        ...(message?.trim() && { message }),
        name: name,
        description: description,
        type: type,
        ...(phoneNumber?.length && type === 'CALL_NOW'
          ? {
            links: phoneNumber.map(item => ({
              adsAccountId: item.adsAccountId,
              link: `tel:+${item.phoneNumber}`
            }))
          }
          : { 
            ...(linksPayload.length > 0 && { links: linksPayload }),
        }),
        ...((templateUrlSpec.length > 0 && objective === 'OUTCOME_AWARENESS') && { template_url_spec: templateUrlSpec }),
        ...(urlTags.length > 0 && { url_tags: urlTags }),
        adcreatives: adcreatives,
        adsAccounts: adsAccounts,
        // degrees_of_freedom_spec: { 
        //     creative_features_spec: {
        //         standard_enhancements: {
        //             enroll_status: "OPT_OUT"
        //         },
        //     }
        // },
      };

      const payload = removeEmptyValues(intialPayload);
      //  console.log({ payload });

      try {
        if (uploadPurpose === 'create') {
          createAdspressoAds(payload).unwrap()
            .then(response => {
              toast({
                position: "top-right",
                title: "Ad creative added",
                status: "success",
                duration: 4000,
                isClosable: true,
              });
              //console.log('Ads creative created successfully:', response);
            })
            .catch(error => {
              const errorMessage = error?.message || "An unexpected error occurred";

              toast({
                position: "top-right",
                title: "Error creating Ad creative",
                description: errorMessage,
                status: "error",
                duration: 4000,
                isClosable: true,
              });
            });
        }
      } catch {
        // handle exception if necessary
      } finally {
        setuploadPurpose(null);
        setMediaType(null);
        setMediaFiles([]); // Clear the media files
        setMediaFilesState({});
        setSelectedAdAccounts([]); // Reset selected ad accounts
        setSelectedAdSets({}); // Clear selected ad sets
        resetForm();
        setactiveDestinationType('');
        setLinks([]);
        setPhoneNumbers([]);
        seturl_tags([]);
      }

    },
  });

  const handleDeleteFile = (indexToDelete) => {
    setMediaFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
  };

  useEffect(() => {
    singleMediaFormik.setFieldValue('mediaFiles', mediaFiles)
  }, [mediaFiles])

  const handleDeleteAd = (adId) => {
    removeAd(adId)
      .unwrap()
      .then(response => {
        toast({
          position: "top-right",
          title: "Ad deleted",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch(error => {
        toast({
          position: "top-right",
          title: "Error deleting Ad",
          status: "error",
          description: error?.data?.message,
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const confirmDelete = () => {
    if (selectedAd) {
      handleDeleteAd(selectedAd);
      setModalOpen(false);
      setSelectedAd(null);
    }
  };

  function checkSameDestinationType(selectedIds, adsets) {
    const filteredAdsets = adsets.filter(adset => selectedIds.includes(adset._id));

    if (filteredAdsets.length === 0) {
      return true;
    }

    // Get the destination_type of the first filtered adset
    const firstDestinationType = filteredAdsets[0].destination_type;

    // Loop through the filtered adsets and check if all have the same destination_type
    for (let i = 1; i < filteredAdsets.length; i++) {
      if (filteredAdsets[i].destination_type !== firstDestinationType) {
        return false;
      }
    }

    setactiveDestinationType(firstDestinationType);


    return true;
  }

  useEffect(() => {
    // console.log(checkSameDestinationType(Object.values(selectedAdSets).flat(), adsetsListData?.data))
    if (Object.values(selectedAdSets)?.flat()?.length > 1) {
      const checkresult = checkSameDestinationType(Object.values(selectedAdSets).flat(), adsetsListData?.data);
      sethasSameDestinationType(checkresult)
    } else if (Object.values(selectedAdSets)?.flat()?.length == 1) {
      //console.log(String(Object.values(selectedAdSets)?.flat()?.[0]));
      let activeSingleAdset = adsetsListData?.data?.filter((adset) => adset._id == String(Object.values(selectedAdSets)?.flat()?.[0]));
      // console.log(activeSingleAdset);
      setactiveDestinationType(activeSingleAdset?.[0]?.destination_type)
      sethasSameDestinationType(true)
    } else {
      setactiveDestinationType('')
    }

  }, [selectedAdSets])


  const isAnyUrlMissing = mediaFiles.some(file => {
    const fileId = file?.id || file?.creativeId;
    const fileState = mediaFilesState[fileId] || {};
    return !fileState.link || fileState.link.trim() === '';
  });

  const updateLinkField = (adsAccountId, field, value) => {
    setLinks(prevLinks => {
      const updatedLinks = prevLinks.map(link =>
        link.adsAccountId === adsAccountId ? { ...link, [field]: value } : link
      );
      singleMediaFormik.setFieldValue('link', updatedLinks);
      return updatedLinks;
    });
  };  

  const handlePhoneNumberChange = (adsAccountId, value) => {
    setPhoneNumbers(prevPhoneNumbers => {
      const updatedPhoneNumbers = prevPhoneNumbers.map(phone =>
        phone.adsAccountId === adsAccountId ? { ...phone, phoneNumber: value } : phone
      );
      singleMediaFormik.setFieldValue('phoneNumber', updatedPhoneNumbers); // Update formik field
      return updatedPhoneNumbers;
    });
  };

  const handleUrlChange = (constructedUrl, adsAccountId) => {
    setLinks((prevLinks) => {
      const updatedLinks = prevLinks.map((link) =>
        link.adsAccountId === adsAccountId ? { ...link, link: constructedUrl } : link
      );
      singleMediaFormik.setFieldValue('link', updatedLinks);
      return updatedLinks;
    });
  };

  const handleSingleUrlChange = (constructedUrl, fileId) => {
    setMediaFilesState(prevState => ({
      ...prevState,
      [fileId]: {
        ...prevState[fileId],
        link: constructedUrl,
      },
    }));
  };

  const handleUrlTagChange = (adsAccountId, value) => {
    seturl_tags(prevUrl => {
      const updatedUrl = prevUrl.map(url =>
        url.adsAccountId === adsAccountId ? { ...url, url_tags: value } : url
      );
      singleMediaFormik.setFieldValue('url_tags', updatedUrl);
      return updatedUrl;
    });
  };

  const handleUrlParamChange = (constructedUrl, adsAccountId) => {
    seturl_tags(prevUrl => {
      const updatedUrl = prevUrl.map(url =>
        url.adsAccountId === adsAccountId ? { ...url, url_tags: constructedUrl } : url
      );
      singleMediaFormik.setFieldValue('url_tags', updatedUrl);
      return updatedUrl;
    });
  };

  const handleFocus = (adsAccountId) => {
    // Set the field as focused when the user starts typing
    setIsFocused(prev => ({
      ...prev,
      [adsAccountId]: true
    }));
  };

  const isAccountsMatching = !selectedAdAccounts.every(account => {
    // Count occurrences of the account's adsAccountId in mediaFiles
    const count = singleMediaFormik.values.mediaFiles.filter(mediaFile =>
      mediaFile.adsAccount?.adsAccountId === account.adsAccountId
    ).length;

    // Return true if the adsAccountId appears at least twice, otherwise false
    return count >= 2;
  });
  
  const allLinksAdded = activeDestinationType !== 'PHONE_CALL' && links.every(link => link?.link !== '');
  const allPhoneNumbersAdded = activeDestinationType === 'PHONE_CALL' && phoneNumbers.every(phone => phone?.phoneNumber !== '');

  const selectedCountMap = mediaFiles?.reduce((acc, file) => {
    const accountId = file?.adsAccount?.adsAccountId;
    if (accountId) {
        acc[accountId] = (acc[accountId] || 0) + 1;
    }
    return acc;
  }, {});

  const errorCardIndices = mediaFiles
    ?.map((file, idx) => {
      const fileId = file?.id || file?.creativeId;
      const fileState = mediaFilesState[fileId];
      const isUrlMissing = !fileState?.link || fileState.link.trim() === '';
      return isUrlMissing ? idx + 1 : null; 
    })
  .filter(Boolean);

  return (
    <>
      <DriveModal
        isDriveModalOpen={isDriveOpen}
        mediaType={mediaType}
        onClose={() => {
          setIsDriveOpen(false);
          setMediaType(null);
          setFileBeingEdited(null);
        }}
        onSubmit={handleFileSelect}
        mediaFormat={adFormik?.values?.format}
        selectedAdAccounts={selectedAdAccounts}
        uploadPurpose={uploadPurpose}
        selectedCountMap={selectedCountMap}
      />

      <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BuildUrlParams links={links} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isSingleUrlModalOpen} onClose={() => setSingleUrlModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BuildUrlParamSingle link={mediaFilesState} onClose={() => setSingleUrlModalOpen(false)} onUrlChange={handleSingleUrlChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UrlParameter urls={url_tags} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirmDelete}
        message="Do you wish to proceed with deleting this Ad?"
      />

      <Flex flex="3" direction="column" gap={2}>
        <Flex direction="column" mb={4}>
          {/* Ad Account Select */}
          <Flex direction={'column'} gap={'10px'} mb={'10px'}>
            <Text fontSize={'14px'} fontWeight={'bold'}>Select Ad accounts</Text>
            <CheckboxGroup
              colorScheme="brand"
              value={selectedAdAccounts.map(account => account.adsAccountId)}
              onChange={handleAdAccountChange}
            >
              {adsAccounts?.map(account => (
                <Box key={account.adsAccountId} px={'5px'} py={'2px'}>
                  <Checkbox value={account.adsAccountId}>
                    <Text fontSize={'14px'} noOfLines={2} maxWidth={'510px'}>
                      {/* {account.adsAccountName.length > 20
                          ? `${account.adsAccountName.substring(0, 20)}...`
                          : account.adsAccountName} */}
                      {account.adsAccountName}
                    </Text>
                  </Checkbox>
                </Box>
              ))}

            </CheckboxGroup>
          </Flex>

          {/* Ad Set Select */}
          <Flex direction="column" gap={'5px'} mb={'10px'}>
            <Text fontSize={'14px'} fontWeight={'bold'}>Select Ad sets</Text>
            <CheckboxGroup
            colorScheme="brand"
            value={Array.from(new Set(Object.values(selectedAdSets).flat()))}
            onChange={handleAdSetChange}
            isDisabled={!selectedAdAccounts.length > 0}
          >
            {adsetsListData?.data?.map((adSet, index) => {
              const isAdSetDisabled = ['ON_PAGE','ON_VIDEO'].includes(adSet?.destination_type) || ['THRUPLAY','TWO_SECOND_CONTINUOUS_VIDEO_VIEWS'].includes(adSet?.optimization_goal) ;
              const tooltipLabel = "Carousel option is not available for this Ad set";

              return (
                <Tooltip
                  key={`${adSet._id}-${index}`}
                  label={tooltipLabel}
                  hasArrow
                  placement="top-start"
                  fontSize={'12px'}
                  isDisabled={!isAdSetDisabled}
                >
                  <Box px="5px" py="2px" cursor={isAdSetDisabled ? 'not-allowed' : 'default'}>
                    <Checkbox
                      value={adSet._id}
                      isDisabled={isAdSetDisabled}
                      display="flex"
                      flex={1}
                    >
                      <Text fontSize="14px" noOfLines={2} maxWidth="510px">
                        {adSet?.name}
                      </Text>
                    </Checkbox>
                  </Box>
                </Tooltip>
              );
            })}
          </CheckboxGroup>

            {!hasSameDestinationType ? (
              <Flex>
                <Text color="red.500" fontSize={'12px'}>Conversion goals don't match &nbsp;
                </Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Box fontSize="14px" p="5px">
                      <Text>
                        The selected Ad sets have different conversion goals. Please select Ad sets with the same goal (either Website or Calls). You can create a separate set of Ads for the other conversion goal thereafter.
                      </Text>
                    </Box>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" color={'red.500'} boxSize={4} />
                </Tooltip>
              </Flex>
            ) : null}
          </Flex>

          <Flex direction="column" mb="10px">
            <Flex alignItems={'center'} gap={2}>
              <Text fontSize="15px" fontWeight={'bold'}>Carousel cards</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="14px" p="5px">
                    <Text>
                      Choose media and enter text for up to ten carousel cards.
                    </Text>
                  </Box>
                }
                fontSize="md"
              >
                <InfoOutlineIcon boxSize={3} pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Text fontSize="13px" flex={1}>
              {mediaFiles.length} of {maxCards} cards added
            </Text>

            {mediaFiles && selectedAdAccounts.some(account => {
              // Count occurrences of the account's adsAccountId in mediaFiles
              const count = mediaFiles.filter(mediaFile =>
                mediaFile.adsAccount?.adsAccountId === account.adsAccountId
              ).length;

              // Return true if there are fewer than 2 cards for this ad account
              return count < 2;
            }) ? (
              <Flex align={'center'} gap={'5px'} px={'10px'} py={'5px'} my={'5px'} bg={bgColor} borderRadius={'md'}>
                <InfoIcon boxSize={3} color={'red.500'} />
                <Text fontSize="13px">
                  {mediaFiles.length === 1 ? "Add at least 2 cards for this ad account." : "Add at least 2 cards for each ad account."}
                </Text>
              </Flex>
            ) : null}
          </Flex>

          {/* Single Select component for each adAccount */}
          <Flex direction="column" flexShrink={0}>
            <Select
              placeholder={"Add cards"}
              width={'150px'}
              name="mediaOption"
              borderRadius={'md'}
              value={mediaType || ""}
              onChange={(e) => {
                setuploadPurpose('create');
                handleMediaTypeChange(selectedAdAccounts, e.target.value);
              }}
              size="sm"
              isDisabled={Object.keys(selectedAdSets)?.length === 0 || !selectedAdAccounts?.length > 0 || !hasSameDestinationType}
            >
              <option value="image">{"Add image cards"}</option>
              <option value="video">{"Add video cards"}</option>
            </Select>
          </Flex>

          {/* Media Previews */}
          {uploadPurpose === 'create' && mediaFiles?.length > 0 && (
            <Box mt={4}>
              {(errorCardIndices?.length > 0 && (activeDestinationType === 'WEBSITE' || activeDestinationType === 'PHONE_CALL')) && (
                  <Card 
                        borderRadius="5px" 
                        p={2}
                        borderLeft={"4px solid rgb(220,55,60)"}
                        mb={2}
                    >
                    <CardBody display="flex" alignItems="center" gap={2} p={1}>
                        <MdBlock style={{ pointerEvents: 'all'}} color="rgb(220,55,60)" />
                        <Text fontSize="14px">
                          Review errors in {errorCardIndices.length === 1 ? 'card' : 'cards'} {formatCardIndices([...errorCardIndices])}.
                        </Text>
                    </CardBody>
                  </Card>
              )}
              <Flex wrap="wrap" gap={2} direction="column">
                {mediaFiles?.map((file, index) => {
                  const fileId = file?.id || file?.creativeId;

                  const fileState = mediaFilesState[fileId] || {};

                  // Checking if URL is empty
                  const isUrlRequired = !fileState.link || fileState.link.trim() === '';

                  return (
                    <Box key={index} p={1} borderWidth={1} borderRadius="md" borderColor={boxBorder} position={'relative'}>
                      <Flex alignItems="center" gap={2} justify="space-between">
                        <Flex alignItems="center" gap={2}>
                          {file?.creativeType === 'image' ? (
                            <img
                              src={file?.url}
                              alt={file?.name}
                              style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '3px' }}
                            />
                          ) : (
                            <img
                              src={file?.picture}
                              style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '3px' }}
                            />
                          )}
                          <Flex direction="column">
                            <Text fontSize="10px" noOfLines={1}>
                              {fileState.name || file?.name || 'No name available'}
                            </Text>
                            <Flex gap={1}>
                              {(activeDestinationType === 'WEBSITE' || objective === 'OUTCOME_AWARENESS') ? (
                                <>
                                  {fileState.name ? (
                                    <Text fontSize="10px" noOfLines={1}>{truncateName(fileState.name)}</Text>
                                  ) : (
                                    <Text fontSize="10px">Enter a headline</Text>
                                  )}
                                  {!fileState.link ? (
                                    <>
                                      <Text fontSize="10px">and</Text>
                                      <Text fontSize="10px">URL&nbsp;
                                        <Tooltip
                                          borderRadius={5}
                                          label={
                                            <Box p="5px" >
                                              <Text fontSize="12px">
                                                Your carousel card {index + 1} doesn't have a destination. Please enter a URL for each card in your carousel.
                                              </Text>
                                            </Box>
                                          }
                                          fontSize="md"
                                        >
                                          <InfoOutlineIcon color={'red.500'} pointerEvents="all" />
                                        </Tooltip>
                                      </Text>
                                    </>
                                  ) : null}
                                </>
                              ) : (activeDestinationType === 'PHONE_CALL') ? (
                                <>
                                  {fileState.name ? (
                                    <Text fontSize="10px" noOfLines={1}>{truncateName(fileState.name)}</Text>
                                  ) : (
                                    <Text fontSize="10px">Enter a headline</Text>
                                  )}
                                  {!fileState.link ? (
                                    <>
                                      <Text fontSize="10px">and</Text>
                                      <Text fontSize="10px">Phone number&nbsp;
                                        <Tooltip
                                          borderRadius={5}
                                          label={
                                            <Box p="5px" >
                                              <Text fontSize="12px">
                                                Your carousel card {index + 1} doesn't have a destination. Please enter a phone number for each card in your carousel.
                                              </Text>
                                            </Box>
                                          }
                                          fontSize="md"
                                        >
                                          <InfoOutlineIcon color={'red.500'} pointerEvents="all" />
                                        </Tooltip>
                                      </Text>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </Flex>
                            <Text fontSize="10px" fontWeight={'bold'} noOfLines={1}>{truncateName(file?.adsAccount?.adsAccountName)}</Text>
                          </Flex>
                        </Flex>
                        <Flex alignItems="center" gap={'5px'}>
                          <Tooltip label="Edit copy" fontSize="xs">
                            <Box>
                              <Icon
                                _hover={{ color: 'gray.500' }}
                                as={openAccordionId === fileId ? FiChevronUp : MdEdit}
                                cursor="pointer"
                                fontSize="14px"
                                onClick={() => toggleAccordion(fileId)}
                              />
                            </Box>
                          </Tooltip>
                          <Tooltip label="Delete" fontSize="xs">
                            <Box>
                              <Icon
                                color="red.500"
                                _hover={{ color: 'gray.400' }}
                                as={MdDelete}
                                cursor="pointer"
                                boxSize={4}
                                onClick={() => handleDeleteFile(index)}
                              />
                            </Box>
                          </Tooltip>
                        </Flex>
                      </Flex>
                      <Collapse in={openAccordionId === fileId} style={{ overflow: 'visible' }}>
                        <Box p={4}>
                          {/* Headline Section */}
                          <Box direction="column" mb={4}>
                            <Flex alignItems="center" mb={2} gap={2}>
                              <Text fontSize="14px" fontWeight="bold">Headline</Text>
                              <Tooltip
                                borderRadius={5}
                                label={
                                  <Box fontSize="14px" p="5px">
                                    <Text>
                                      Add up to five brief headlines to let people know what your ad is about. Each
                                      headline can have a maximum of 255 characters. Headlines won't appear in all
                                      placements.
                                    </Text>
                                  </Box>
                                }
                                fontSize="md"
                              >
                                <InfoOutlineIcon pointerEvents="all" />
                              </Tooltip>
                            </Flex>
                            <Input
                              placeholder="Tell people what your ad is about..."
                              size="sm"
                              borderRadius="md"
                              value={fileState.name || ''}
                              onChange={(e) => handleInputChange(fileId, 'name', e.target.value)}
                            />
                          </Box>

                          {/* Description Section */}
                            <Box direction="column" mb={4}>
                                <Flex alignItems="center" mb={2} gap={2}>
                                <Text fontSize="14px" fontWeight="bold">Description</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                    <Box fontSize="14px" p="5px">
                                        <Text>
                                        Add up to five link descriptions to emphasize why people should visit your
                                        website. This won't appear in all placements.
                                        </Text>
                                    </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                                </Flex>
                                <Textarea
                                placeholder="Include additional details"
                                size="sm"
                                borderRadius="md"
                                value={fileState.description || ''}
                                onChange={(e) => handleInputChange(fileId, 'description', e.target.value)}
                                rows={2}
                                />
                            </Box>


                            {/* URL Link Section */}
                            {activeDestinationType === 'PHONE_CALL' ? (
                              <>
                                <Box direction="column" mb={'10px'}>
                                  <Flex alignItems="center" mb={2} gap={2}>
                                    <Text fontWeight="bold" fontSize="14px">Call to action</Text>
                                    <Tooltip
                                      borderRadius={5}
                                      label={
                                        <Box fontSize="sm" p="5px">
                                          <Text>This is the only available option.</Text>
                                        </Box>
                                      }
                                      fontSize="md"
                                    >
                                      <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                  </Flex>
                                  <Select
                                    name="type"
                                    borderRadius="md"
                                    value={singleMediaFormik.values.type}
                                    onChange={singleMediaFormik.handleChange}
                                    onBlur={singleMediaFormik.handleBlur}
                                    size="sm"
                                    isDisabled
                                  >
                                    <option value="CALL_NOW">Call Now</option>
                                  </Select>
                                </Box>
                                <Box>
                                  <Flex alignItems="center" mt={'10px'} mb={2}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Call now</Text>
                                    <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                                    <Tooltip
                                      borderRadius={5}
                                      label={
                                        <Box fontSize="sm" p="5px">
                                          <Text>You can use a different phone number for each carousel card. This can be helpful if you have different phone numbers or extensions.</Text>
                                        </Box>
                                      }
                                      fontSize="md"
                                    >
                                      <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                  </Flex>
                                  <PhoneInput
                                    country="in"
                                    value={fileState.link || ''}
                                    onChange={(value) => handleInputChange(fileId, 'link', value)}
                                    inputProps={{
                                      name: 'phoneNumber',
                                      required: true,
                                    }}
                                    enableSearch={true}
                                    searchPlaceholder="Search"
                                  />
                                  {isUrlRequired && (
                                    <Text fontSize="12px" color="red.500" mt={2}>
                                      Your carousel card {index + 1} doesn't have a destination. Please enter a phone number for each card in your carousel.
                                    </Text>
                                  )}
                                </Box>
                              </>
                            ) :
                              <Box direction="column" mb={4}>
                                <Flex alignItems="center" mb="5px">
                                  <Text fontSize="14px" fontWeight="bold">Website URL</Text>
                                  <Text display="inline-flex" fontSize="18px" color="red.400" ml={2} mr={2}>*</Text>
                                  <Tooltip
                                    borderRadius={5}
                                    label={
                                      <Box fontSize="14px" p="5px">
                                        <Text>
                                          Enter the URL for the web page that you want people to visit.
                                        </Text>
                                      </Box>
                                    }
                                    fontSize="md"
                                  >
                                    <InfoOutlineIcon pointerEvents="all" />
                                  </Tooltip>
                                </Flex>
                                <Input
                                  placeholder="http://www.example.com/page"
                                  size="sm"
                                  borderRadius="md"
                                  value={fileState.link || ''}
                                  onChange={(e) => handleInputChange(fileId, 'link', e.target.value)}
                                  isInvalid={isUrlRequired}
                                />
                                <Flex mt={2}>
                                  <Button onClick={() => {
                                    setSingleUrlModalOpen(true)
                                    setSelectedAccountId(fileId);
                                  }}
                                    variant="link"
                                    color='brand'>
                                    <Text fontSize={'12px'}>{'Build a URL parameter'}</Text>
                                  </Button>
                                </Flex>
                                {isUrlRequired && (
                                  <Text fontSize="12px" color="red.500" mt={2}>
                                    Your carousel card {index + 1} doesn't have a destination. Please enter a website URL for each card in your carousel.
                                  </Text>
                                )}
                              </Box>
                            }
                        </Box>
                      </Collapse>
                    </Box>
                  );
                })}
              </Flex>
            </Box>
          )}
        </Flex>

        <Divider />

        {/* Primary Text Section */}
        <Box direction="column" mb={4}>
          <Flex alignItems="center" mb={2}>
            <Text fontWeight="bold" fontSize="14px" mr={2}>Primary text</Text>
            {/* <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text> */}
            <Tooltip
              borderRadius={5}
              label={
                <Box fontSize="sm" p="5px">
                  <Text>
                    The primary text for your ad appears in most placements, though the position
                    varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                    characters or less.
                  </Text>
                </Box>
              }
              fontSize="md"
            >
              <InfoOutlineIcon pointerEvents="all" />
            </Tooltip>
          </Flex>
          <Textarea
            size="sm"
            placeholder="Tell people what your ad is about..."

            name="message"
            value={singleMediaFormik.values.message}
            onChange={singleMediaFormik.handleChange}
            onBlur={singleMediaFormik.handleBlur}
            borderRadius="md"
          />
          {singleMediaFormik.touched.message && singleMediaFormik.errors.message ? (
            <Text color="red.500" fontSize="12px">{singleMediaFormik.errors.message}</Text>
          ) : null}
        </Box>

        {/* Call to action Section */}
        <Box direction="column" mb={'10px'}>
            <Flex alignItems="center" mb={2} gap={2}>
                <Text fontWeight="bold" fontSize="14px">Call to action</Text>
                <Tooltip
                borderRadius={5}
                label={
                    <Box fontSize="sm" p="5px">
                    <Text>This is the only available option.</Text>
                    </Box>
                }
                fontSize="md"
                >
                <InfoOutlineIcon pointerEvents="all" />
                </Tooltip>
            </Flex>
            {activeDestinationType === 'PHONE_CALL' ?
              <Select
                name="type"
                borderRadius="md"
                value={singleMediaFormik.values.type}
                onChange={singleMediaFormik.handleChange}
                onBlur={singleMediaFormik.handleBlur}
                size="sm"
                isDisabled
            >
                <option value="CALL_NOW">Call Now</option>
              </Select> 
            :
              <Select
                  name="type"
                  borderRadius="md"
                  value={singleMediaFormik.values.type}
                  onChange={singleMediaFormik.handleChange}
                  onBlur={singleMediaFormik.handleBlur}
                  size="sm"
              >
              {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                  <option key={option.value} value={option.value}>
                      {option.label}
                  </option>
              ))}
              </Select>
            }
        </Box>

        {singleMediaFormik.touched.mediaType && singleMediaFormik.errors.mediaFiles ? (
          <Text color="red.500" fontSize="12px">{singleMediaFormik.errors.mediaFiles}</Text>
        ) : null}

        {/* Links Section */}
        {(['WEBSITE', 'PHONE_CALL'].includes(activeDestinationType) &&  !['OUTCOME_TRAFFIC', 'OUTCOME_ENGAGEMENT'].includes(objective)) || objective === 'OUTCOME_AWARENESS' ? (
          <>
            <Divider pt={2} />
            {selectedAdAccounts.map((account, index) => {
              const link = links.find(item => item.adsAccountId === account.adsAccountId)?.link || '';
              const phoneNumber = phoneNumbers.find(item => item.adsAccountId === account.adsAccountId)?.phoneNumber || '';
              const isValidNo = isValidPhoneNumber(phoneNumber);
              const caption = links.find(item => item.adsAccountId === account.adsAccountId)?.caption || '';
              const app_id = links.find(item => item.adsAccountId === account.adsAccountId)?.app_id || '';
              const isUrlValid = isValidUrl(link);
              const hasFocus = isFocused[account.adsAccountId];
              const urlTag = url_tags.find(item => item.adsAccountId === account.adsAccountId)?.url_tags || '';

              return (
                <>
                  <Flex key={`${account.adsAccountId}-${index}`} direction="column">
                    <Flex alignItems="center" gap={2}>
                      <Text fontWeight="bold" fontSize="14px" mb={'5px'}>
                        {truncateString(account.adsAccountName, 40)}
                      </Text>
                      <Text fontSize="12px">({account.adsAccountId})</Text>
                    </Flex>
                    {activeDestinationType === 'PHONE_CALL' ? 
                      <Box pl={'5px'} mb={2}>
                        <Flex alignItems="center" mb={'5px'} >
                            <Text fontWeight="bold" fontSize="14px">
                              Call now
                            </Text>
                            <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                            <Tooltip
                              borderRadius={5}
                              label={
                                <Box fontSize="12px" p="5px">
                                  <Text>Add the phone number for your business. When
                                  someone taps your ad, they can make a call to your business.</Text>
                                </Box>
                              }
                              fontSize="md"
                            >
                              <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                          </Flex>
                          <Box position="relative">
                              <Flex justifyContent={'space-between'}>  
                                <PhoneInput
                                  country="in"
                                  value={phoneNumber}
                                  onChange={(value) => handlePhoneNumberChange(account.adsAccountId, value)}
                                  name={`phoneNumber[${index}].phoneNumber`}
                                  inputProps={{
                                    name: `phoneNumber[${index}].phoneNumber`,
                                    required: true,
                                    onFocus: () => {
                                      // mark this account's phone input as focused
                                      handleFocus(account.adsAccountId, "phoneNumber");
                                      setShowSavedPhones(prev => ({ ...prev, [account.adsAccountId]: true }));
                                    },
                                    onBlur: () => {
                                      // let option mousedown run first
                                      setTimeout(() => {
                                        setShowSavedPhones(prev => ({ ...prev, [account.adsAccountId]: false }));
                                      }, 120);
                                    }
                                  }}
                                  enableSearch
                                  searchPlaceholder="Search"
                                />
                                <Button
                                    px={8}
                                    as={Link}
                                    href={`${process.env.REACT_APP_CONVERSATION_BASE_URL}/authenticateHustle?token=${userInfo?.token}`}
                                    leftIcon={<Icon as={FiPhoneCall} />}
                                    colorScheme="brand"
                                    size="sm"
                                    isExternal
                                  >
                                    AI Call Center
                                </Button>
                              </Flex>

                              {/* Saved numbers dropdown - only when focused AND we have numbers */}
                              {Array.isArray(callsData?.phoneNumbers)
                                && callsData.phoneNumbers.length > 0
                                && showSavedPhones[account.adsAccountId] && (
                                  <Box
                                    position="absolute"
                                    px={1}
                                    mt={1}
                                    borderWidth="1px"
                                    borderRadius="md"
                                    bg="white"
                                    boxShadow="md"
                                    maxH="180px"
                                    overflowY="auto"
                                    zIndex={20}
                                  >
                                    {callsData.phoneNumbers.map((pn) => {
                                      const isSelected = phoneNumber === pn.number;
                                      return (
                                        <Box
                                          key={pn.id}
                                          as="button"
                                          type="button"
                                          width={'100%'}
                                          px={3}
                                          py={2}
                                          bg={isSelected ? "brand.50" : ListBgColor}
                                          _hover={{ bg: hoverBorder }}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                          onMouseDown={(e) => {
                                            e.preventDefault();
                                            const cleanNumber = pn.number?.replace(/^\+/, '');
                                            handlePhoneNumberChange(account.adsAccountId, cleanNumber);
                                            setShowSavedPhones(prev => ({ ...prev, [account.adsAccountId]: false }));
                                          }}
                                        >
                                           <Text fontWeight="medium" fontSize={'12px'} noOfLines={1}>{pn.number}</Text>
                                        </Box>
                                      );
                                    })}
                                  </Box>
                              )}
                          </Box>

                          {/* Show validation error if URL is empty or invalid */}
                          {hasFocus && phoneNumber === '' && (
                            <Text color="red.500" fontSize="12px" mt={'5px'}>
                            {'Phone number is required'}
                            </Text>
                          )}
                          {hasFocus && !isValidNo && phoneNumber !== '' && (
                            <Text color="red.500" fontSize="12px" mt={'5px'}>
                              {'Please enter valid phone number'}
                            </Text>
                          )}
                      </Box>
                    : 
                      <Box pl={'5px'} mb={1}>
                          <Flex alignItems="center" mb={'5px'} >
                            <Text fontWeight="bold" fontSize="14px">
                              Website URL
                            </Text>
                            <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                            <Tooltip
                              borderRadius={5}
                              label={
                                <Box fontSize="12px" p="5px">
                                  <Text>Enter the URL for the webpage you want people to visit</Text>
                                </Box>
                              }
                              fontSize="md"
                            >
                              <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                          </Flex>
                          <Box position="relative">
                            <Flex justifyContent={'space-between'} gap={4}>
                              <Input
                                type="url"
                                name={`link[${index}].link`}
                                bg="#fff"
                                borderRadius="md"
                                placeholder="Enter a URL"
                                autoComplete="off"
                                value={link}
                                onChange={(e) => updateLinkField(account.adsAccountId, 'link', e.target.value)}
                                onFocus={() => {
                                  handleFocus(account.adsAccountId, 'link');
                                  setShowSavedLanders((prev) => ({ ...prev, [account.adsAccountId]: true }));
                                }}
                                onBlur={() => {
                                  // let option mousedown run first
                                  setTimeout(() => {
                                    setShowSavedLanders((prev) => ({ ...prev, [account.adsAccountId]: false }));
                                  }, 120);
                                }}
                                size="sm"
                              />
                              <Button
                                  px={5}
                                  as={Link}
                                  href={`${process.env.REACT_APP_CANVA_BASE_URL}/authenticateHustle?token=${userInfo?.token}`}
                                  colorScheme="blue"
                                  size="sm"
                                  isExternal
                                  leftIcon={<Icon as={IoBuildOutline} />}
                                >
                                  Build More
                                </Button>
                            </Flex>

                              {/* Saved lander projects dropdown */}
                              {Array.isArray(landersData?.deployedProjects) &&
                                landersData.deployedProjects.length > 0 &&
                                showSavedLanders[account.adsAccountId] && (
                                  <Box
                                    position="absolute"
                                    mt={1}
                                    borderWidth="1px"
                                    borderRadius="md"
                                    bg="white"
                                    boxShadow="md"
                                    maxH="180px"
                                    overflowY="auto"
                                    zIndex={20}
                                    width="100%"
                                  >
                                    {landersData.deployedProjects.map((project) => {
                                      const isSelected = link === project.deploymentUrl;
                                      return (
                                        <Box
                                          key={project.uiId}
                                          as="button"
                                          type="button"
                                          width="100%"
                                          px={2}
                                          py={2}
                                          textAlign="left"
                                          bg={isSelected ? "brand.50" : ListBgColor}
                                          _hover={{ bg: hoverBorder }}
                                          onMouseDown={(e) => {
                                            e.preventDefault();
                                            updateLinkField(account.adsAccountId, "link", project.deploymentUrl);
                                            setShowSavedLanders((prev) => ({ ...prev, [account.adsAccountId]: false }));
                                          }}
                                        >
                                          <Text fontSize="12px" noOfLines={1}>
                                            {project.deploymentUrl}
                                          </Text>
                                        </Box>
                                      );
                                    })}
                                  </Box>
                                )}
                          </Box>
                          <Flex mt={1} mb={1}>
                            <Button onClick={() => {
                              setUrlModalOpen(true)
                              setSelectedAccountId(account?.adsAccountId);
                            }}
                            variant="link"
                            color='brand'>
                              <Text fontSize={'12px'} mt={'5px'}>{'Build a URL parameter'}</Text>
                            </Button>
                          </Flex>
                          {/* Show validation error if URL is empty or invalid */}
                          {hasFocus && link === '' && (
                            <Text color="red.500" fontSize="12px">
                              {'URL is required'}
                            </Text>
                          )}
                          {hasFocus && !isUrlValid && link !== '' && (
                            <Text color="red.500" fontSize="12px" mt={'5px'}>
                              {'Please enter valid URL'}
                            </Text>
                          )}
                      </Box>
                    }

                    {activeDestinationType === 'PHONE_CALL' ? null : 
                      <Box pl={'5px'} mb={2}>
                          <Text fontWeight="bold" fontSize={'14px'} mb={'5px'}>Display link</Text>
                          <Input
                            type="url"
                            name={`link[${index}].caption`}
                            bg="#fff"
                            borderRadius="md"
                            placeholder="Enter URL"
                            value={caption}
                            onChange={(e) => updateLinkField(account.adsAccountId, 'caption', e.target.value)}
                            size="sm"
                          />
                      </Box>
                    }

                    {objective === 'OUTCOME_AWARENESS' ? 
                      <Box pl={'5px'} mb={2}>
                          <Flex alignItems="center" gap={2}>
                            <Text fontWeight="bold" fontSize={'14px'} mb={'5px'}>Mobile app</Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="sm" p="5px">
                                        <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                    </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                          </Flex>
                        <Select
                            name={`link[${index}].app_id`}
                            bg="#fff"
                            size="sm"
                            borderRadius="md"
                            onChange={(e) => updateLinkField(account.adsAccountId, 'app_id', e.target.value)}
                            value={app_id}
                        >
                            <option value="">Choose app</option>
                            {advertisableApps
                                ?.find(app => app.adsAccountId === account.adsAccountId)
                                ?.apps
                                ?.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.name}
                                  </option>
                            ))}
                        </Select>
                      </Box>
                    :null}
                    
                    {['APP', 'WHATSAPP', 'PHONE_CALL'].includes(activeDestinationType) ? null :
                      <Box pl={'5px'}>
                        <Flex alignItems={'center'}>
                          <Text mb={2} fontWeight="bold" fontSize="14px">
                            URL parameters{" "}
                            {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                            <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                          </Text>
                          <Tooltip
                            borderRadius={5}
                            label={
                              <Box fontSize="12px" p={'5px'}>
                                <Text >
                                  Add parameters to the end of your website URL to track where your visitors are coming from.
                                </Text>
                              </Box>
                            }
                            fontSize="md"
                          >
                            <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                          </Tooltip>
                        </Flex>

                        <Input
                          type="url"
                          name={`urlTag[${index}].urlTag`}
                          bg="#fff"
                          borderRadius="md"
                          placeholder="key1=value1&key2=value2"
                          value={urlTag}
                          onChange={(e) => handleUrlTagChange(account.adsAccountId, e.target.value)}
                          onFocus={() => handleFocus(account.adsAccountId)}
                          size="sm"
                        />
                        <Flex mt={1} mb={2}>
                          <Button 
                            onClick={() => {
                            setUrlParamModalOpen(true)
                            setSelectedAccountId(account?.adsAccountId);
                          }}
                            variant="link"
                            color='brand'
                            >
                            <Text fontSize={'12px'} mt={'5px'}>{'Build a URL parameter'}</Text>
                          </Button>
                        </Flex>
                      </Box>
                    }
                  </Flex>
                  <Divider  />
                </>
              );
            })}
          </>
        ):null}

        {/* Save Button */}
        <Flex justifyContent="flex-start" mt="10px">
          <Button
            colorScheme="brand"
            onClick={() => {
              singleMediaFormik.handleSubmit();
            }}
            isLoading={isAdsCreating || isAdspressoAdsetUpdating}
            size="sm"
            isDisabled={
              mediaFiles?.length < 2 > 0 ||
              isAnyUrlMissing ||
              !hasSameDestinationType ||
              (activeDestinationType !== 'PHONE_CALL' && !allLinksAdded) ||
              (activeDestinationType === 'PHONE_CALL' && !allPhoneNumbersAdded) ||
              isAccountsMatching
            }
          >
            Save
          </Button>
        </Flex>

        {/* {uploadedCreativesList?.length > 0 && (
          <>
            <Divider my="10px" />
            <Flex direction="column" gap={2}>
              {uploadedCreativesList}
            </Flex>
          </>
        )} */}
      </Flex>
    </>
  );
};

export default CarouselObjectiveMediaCreative;